import React from 'react';
import { Menu, Bell, Search } from 'lucide-react';

const Header = ({ onToggleSidebar, userProfile }) => {
  const getCurrentGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="header-menu-btn" onClick={onToggleSidebar}>
          <Menu size={24} />
        </button>
        <div className="header-greeting">
          <h2>{getCurrentGreeting()}!</h2>
          <p>Let's make today productive</p>
        </div>
      </div>

      <div className="header-right">
        <div className="search-box">
          <Search size={18} />
          <input type="text" placeholder="Search todos..." />
        </div>
        
        <button className="header-icon-btn">
          <Bell size={20} />
          <span className="notification-badge">3</span>
        </button>

        <div className="user-avatar">
          <div className="avatar-circle">
            {userProfile?.name ? userProfile.name.charAt(0).toUpperCase() : 'U'}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
